import Breadcrumb from "components/Common/Breadcrumb";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Card,
  CardBody,
  Container,
  Form,
  Input,
  Label,
  Modal,
  Row,
} from "reactstrap";
import Select from "react-select";
// editor
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { fetchNodeData, FetchNodePostData } from "utils/common-fetchData"; // Added import
import secureLocalStorage from "react-secure-storage"; // Added import
import Swal from "sweetalert2"; // Added import
import Loader from "pages/Separate/Loader"; // Added import
import { copyToClipBoard } from "pages/Separate/copyText";
import { Editor } from "@tinymce/tinymce-react";
import configure from "configure";
// import { Draggable } from "devextreme-react";
import { ResizableBox } from "react-resizable";
import Draggable from "react-draggable";

const LetterAddTemplate = () => {
  const [fixButtons, setFixButtons] = useState(false);
  const [edit_status, setEditStatus] = useState(false);
  const [loading, setLoading] = useState(false); // Added for API call
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [templateData, setTemplateData] = useState({
    name: "",
    description: "<p></p>",
  }); // Added for form data
  const navigate = useNavigate();

  const FetchOptions = async () => {
    const response = await fetchNodeData(
      setLoading,
      `LetterTypes`,
      secureLocalStorage.getItem("auth_token")
    );
    console.log(`response: `, response);

    if (response.status) {
      const formatted = response.data.map((x) => ({
        value: x.id,
        label: x.LetterName,
      }));
      console.log("Formatted Options: ", formatted);
      setOptions(formatted);
    } else {
      setOptions([]); // instead of setData([])
    }
  };

  const handleSave = async () => {
    if (
      !templateData.name?.trim() ||
      !selectedOption?.value ||
      !templateData.description?.getContent()?.trim()
    ) {
      Swal.fire({
        icon: "warning",
        text: "All fields are required",
        showConfirmButton: true,
      });
      return;
    }
    try {
      setLoading(true);
      const formData = {
        name: templateData.name,
        type: selectedOption?.value,
        description: templateData.description.getContent(),
      };
      const response = await FetchNodePostData(
        setLoading,
        `staffTemplate`,
        secureLocalStorage?.getItem("auth_token"),
        formData
      );
      if (response.status === 200) {
        Swal.fire({
          icon: "success",
          text: " Template Added Successfully",
          showConfirmButton: true,
        });
        navigate(`${configure.appUrl}setting/companysetting?tab=4`)
      } else {
        Swal.fire({
          icon: "error",
          text: response.data?.message || "Failed to add  template",
          showConfirmButton: true,
        });
      }
    } catch (err) {
      console.error("Error adding  template:", err);
      Swal.fire({
        icon: "error",
        text: err.message || "An error occurred while adding the  template",
        showConfirmButton: true,
      });
    } finally {
      setLoading(false);
    }
  };

  document.addEventListener("scroll", () => {
    if (window.scrollY > 160) {
      setFixButtons(true);
    } else {
      setFixButtons(false);
    }
  });

  const handleEditorChange = (content, editor) => {
    setTemplateData({
      ...templateData,
      description: editor,
    });
  };

  useEffect(() => {
    FetchOptions();
  }, []);

  return (
    <div>
      {loading && <Loader />}
      <React.Fragment>
        <div className="page-content mb-4">
          <Container fluid>
            <Breadcrumb title="Dashboard" breadcrumbItem="Document Template" />
            <Row className="gx-4 justify-content-between di-flex align-items-top">
              <div
                className={`flex-column fixed-buttons ${fixButtons ? "d-flex" : "d-none"
                  }`}
              >
                <button
                  className="btn btn-purple border-radius fix-btn"
                  onClick={handleSave} // Added onClick handler
                >
                  <i className="fas fa-save me-2"></i>
                  <span>Save</span>
                </button>
                <a
                  onClick={() =>
                    navigate(`${configure.appUrl}setting/companysetting?tab=3`)
                  }
                  className="btn btn-red border-radius fix-btn"
                >
                  <i className="dripicons-cross me-2 icon-center"></i>
                  <span>Cancel</span>
                </a>
              </div>

              <Card>
                <CardBody>
                  <div className="mb-20">
                    <Row>
                      <div className="col-md-6">
                        <h4>Add Document Template</h4>
                      </div>
                      <div className="col-md-6 text-md-end">
                        <button
                          className="border-radius btn text-white me-md-0 me-2 btn-purple"
                          onClick={handleSave} // Added onClick handler
                        >
                          <i className="fas fa-save me-2"></i>SAVE
                        </button>
                        <a
                          className="border-radius btn text-white ms-md-2 btn-red"
                          onClick={() => navigate(-1)}
                        >
                          <i className="dripicons-cross me-2 icon-center"></i>
                          CANCEL
                        </a>
                      </div>
                    </Row>
                  </div>
                  <Form className="row align-items-end">
                    <div className="mb-3 col-md-3">
                      <Label htmlFor="formrow-firstname-Input">Name</Label>
                      <Input
                        type="text"
                        required
                        className="form-control"
                        id="formrow-firstname-Input"
                        placeholder="Enter Name"
                        value={templateData.name} // Controlled input
                        onChange={(e) =>
                          setTemplateData({
                            ...templateData,
                            name: e.target.value,
                          })
                        }
                      />
                    </div>
                    <div className="mb-3 col-md-3">
                      <Label htmlFor="formrow-firstname-Input">
                        Document Type
                      </Label>
                      <Select
                        required
                        className="basic-multi-select"
                        classNamePrefix="select"
                        options={options}
                        value={selectedOption}
                        onChange={(value) => setSelectedOption(value)}
                      />
                    </div>
                    <div className="mb-3 col-md-3">
                      <a
                        className="border-radius btn text-white me-md-0 me-2 btn-purple"
                        onClick={() => {
                          setEditStatus(true);
                        }}
                      >
                        Dynamic Fields
                      </a>
                    </div>
                    <div className="mb-3 col-md-12">
                      <Label htmlFor="formrow-firstname-Input">
                        Description
                      </Label>
                      <Editor
                        initialValue={templateData?.description}
                        apiKey="w6fz9u4rgsouz7jqcyy4lflpolp0tjwkx1bzoc70ntetxwys"
                        init={{
                          height: 800,
                          menubar: true,
                          plugins: [
                            "a11ychecker",
                            "accordion",
                            "advlist",
                            "advcode",
                            "advtable",
                            "autolink",
                            "checklist",
                            "export",
                            "lists",
                            "link",
                            "image",
                            "charmap",
                            "anchor",
                            "searchreplace",
                            "visualblocks",
                            "powerpaste",
                            "fullscreen",
                            "formatpainter",
                            "insertdatetime",
                            "media",
                            "table",
                            "wordcount",
                            "code",
                            "pagebreak",
                            "quickbars",
                            "codesample",
                            "textcolor",
                          ],
                          toolbar:
                            "undo redo | casechange blocks | bold italic backcolor | fontselect fontsizeselect |" +
                            "alignleft aligncenter alignright alignjustify | " +
                            "bullist numlist checklist outdent indent | removeformat | a11ycheck code table | exportpdf |",
                          fontsize_formats: "8pt 10pt 12pt 14pt 18pt 24pt 36pt",
                        }}
                        // onEditorChange={handleEditorInit}
                        onEditorChange={handleEditorChange}
                      />
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Row>
          </Container>
        </div>

        {edit_status ? (
          <Draggable
            handle=".drag-header" // drag only by header
            bounds="body" // prevent moving off-screen
          >
            <div
              style={{
                position: "fixed",
                top: "10%", // <<< SET YOUR OWN POSITION HERE
                left: "15%",
                transform: "translateX(-50%)",
                zIndex: 999999,
              }}
            >
              {/* RESIZABLE WRAPPER */}
              <ResizableBox
                width={1000}
                height={540}
                minConstraints={[650, 350]}
                maxConstraints={[1500, 900]}
                resizeHandles={["se"]}
              >
                {/* MAIN MODAL CONTENT */}
                <div
                  className="modal-content"
                  style={{
                    height: "100%",
                    // overflow: "auto",
                    zIndex: 999999,
                  }}
                >
                  {/* HEADER (DRAG HANDLE) */}
                  <div
                    className="modal-header drag-header"
                  // style={{
                  //   cursor: "move",
                  //   userSelect: "none",
                  // }}
                  >
                    <h5 className="modal-title mt-0 mb-3">Dynamic Fields</h5>

                    <button
                      type="button"
                      onClick={() => setEditStatus(false)}
                      className="btn-modal-close"
                    >
                      <span aria-hidden="true" className="btn-modal-span">
                        ×
                      </span>
                    </button>
                  </div>

                  {/* BODY */}
                  <div className="modal-body">
                    <Row>
                      <div className="d-flex flex-wrap position-relative">
                        {/* ---------------------------- */}
                        {/* FULL DYNAMIC FIELDS LIST     */}
                        {/* ---------------------------- */}

                        <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2 ">
                          <label htmlFor="" className="col-4 mb-0">
                            Employee Name
                          </label>
                          <div className="p-2 me-3 col-5 bg-dynamic-field">
                            {"$emp_name"}
                          </div>
                          <button
                            onClick={() => copyToClipBoard(0)}
                            value="$emp_name"
                            className="p-2 fas fa-copy copyBtn h-100 col-2 btn btn-primary btn-sm"
                          ></button>
                        </div>

                        <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                          <label htmlFor="" className="col-4 mb-0">
                            Joining Date
                          </label>
                          <div className="p-2 me-3 col-5 bg-dynamic-field">
                            {"$join_date"}
                          </div>
                          <button
                            onClick={() => copyToClipBoard(1)}
                            value="$join_date"
                            className="p-2 fas fa-copy copyBtn h-100 col-2 btn btn-primary btn-sm"
                          ></button>
                        </div>

                        <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                          <label htmlFor="" className="col-4 mb-0">
                            Employee Id
                          </label>
                          <div className="p-2 me-3 col-5 bg-dynamic-field">
                            {"$emp_id"}
                          </div>
                          <button
                            onClick={() => copyToClipBoard(2)}
                            value="$emp_id"
                            className="p-2 fas fa-copy copyBtn h-100 col-2 btn btn-primary btn-sm"
                          ></button>
                        </div>

                        <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                          <label htmlFor="" className="col-4 mb-0">
                            Designation
                          </label>
                          <div className="p-2 me-3 col-5 bg-dynamic-field">
                            {"$designation"}
                          </div>
                          <button
                            onClick={() => copyToClipBoard(3)}
                            value="$designation"
                            className="p-2 fas fa-copy copyBtn h-100 col-2 btn btn-primary btn-sm"
                          ></button>
                        </div>

                        <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                          <label htmlFor="" className="col-4 mb-0">
                            Basic Salary
                          </label>
                          <div className="p-2 me-3 col-5 bg-dynamic-field">
                            {"$basic_salary"}
                          </div>
                          <button
                            onClick={() => copyToClipBoard(4)}
                            value="$basic_salary"
                            className="p-2 fas fa-copy copyBtn h-100 col-2 btn btn-primary btn-sm"
                          ></button>
                        </div>

                        <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                          <label htmlFor="" className="col-4 mb-0">
                            Dearness Allowance
                          </label>
                          <div className="p-2 me-3 col-5 bg-dynamic-field">
                            {"$dearness_allowance"}
                          </div>
                          <button
                            onClick={() => copyToClipBoard(5)}
                            value="$dearness_allowance"
                            className="p-2 fas fa-copy copyBtn h-100 col-2 btn btn-primary btn-sm"
                          ></button>
                        </div>

                        <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                          <label htmlFor="" className="col-4 mb-0">
                            House Rent Allowance
                          </label>
                          <div className="p-2 col-5 me-3 bg-dynamic-field">
                            {"$house_rent"}
                          </div>
                          <button
                            onClick={() => copyToClipBoard(6)}
                            value="$house_rent"
                            className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                          ></button>
                        </div>

                        <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                          <label htmlFor="" className="col-4 mb-0">
                            Conveyance
                          </label>
                          <div className="p-2 col-5 me-3 bg-dynamic-field">
                            {"$conveyance"}
                          </div>
                          <button
                            onClick={() => copyToClipBoard(7)}
                            value="$conveyance"
                            className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                          ></button>
                        </div>

                        <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                          <label htmlFor="" className="col-4 mb-0">
                            Address line 1
                          </label>
                          <div className="p-2 col-5 me-3 bg-dynamic-field">
                            {"$address_1"}
                          </div>
                          <button
                            onClick={() => copyToClipBoard(8)}
                            value="$address_1"
                            className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                          ></button>
                        </div>

                        <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                          <label htmlFor="" className="col-4 mb-0">
                            Address line 2
                          </label>
                          <div className="p-2 col-5 me-3 bg-dynamic-field">
                            {"$address_2"}
                          </div>
                          <button
                            onClick={() => copyToClipBoard(9)}
                            value="$address_2"
                            className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                          ></button>
                        </div>

                        <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                          <label htmlFor="" className="col-4 mb-0">
                            City
                          </label>
                          <div className="p-2 col-5 me-3 bg-dynamic-field">
                            {"$city"}
                          </div>
                          <button
                            onClick={() => copyToClipBoard(10)}
                            value="$city"
                            className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                          ></button>
                        </div>

                        <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                          <label htmlFor="" className="col-4 mb-0">
                            State
                          </label>
                          <div className="p-2 col-5 me-3 bg-dynamic-field">
                            {"$state"}
                          </div>
                          <button
                            onClick={() => copyToClipBoard(11)}
                            value="$state"
                            className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                          ></button>
                        </div>

                        <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                          <label htmlFor="" className="col-4 mb-0">
                            Country
                          </label>
                          <div className="p-2 col-5 me-3 bg-dynamic-field">
                            {"$country"}
                          </div>
                          <button
                            onClick={() => copyToClipBoard(12)}
                            value="$country"
                            className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                          ></button>
                        </div>

                        <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                          <label htmlFor="" className="col-4 mb-0">
                            Pincode
                          </label>
                          <div className="p-2 col-5 me-3 bg-dynamic-field">
                            {"$pincode"}
                          </div>
                          <button
                            onClick={() => copyToClipBoard(13)}
                            value="$pincode"
                            className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                          ></button>
                        </div>
                        <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                          <label htmlFor="" className="col-4 mb-0">
                            Company name
                          </label>
                          <div className="p-2 col-5 me-3 bg-dynamic-field">
                            {"$company_name"}
                          </div>
                          <button
                            onClick={() => copyToClipBoard(13)}
                            value="$company_name"
                            className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                          ></button>
                        </div>
                        <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                          <label htmlFor="" className="col-4 mb-0">
                            Shift start and end time
                          </label>
                          <div className="p-2 col-5 me-3 bg-dynamic-field">
                            {"$shift_start_and_end_time"}
                          </div>
                          <button
                            onClick={() => copyToClipBoard(13)}
                            value="$shift_start_and_end_time"
                            className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                          ></button>
                        </div>
                        <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                          <label htmlFor="" className="col-4 mb-0">
                            Total salary
                          </label>
                          <div className="p-2 col-5 me-3 bg-dynamic-field">
                            {"$total_salary"}
                          </div>
                          <button
                            onClick={() => copyToClipBoard(13)}
                            value="$total_salary"
                            className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                          ></button>
                        </div>
                        <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                          <label htmlFor="" className="col-4 mb-0">
                            Department
                          </label>
                          <div className="p-2 col-5 me-3 bg-dynamic-field">
                            {"$department"}
                          </div>
                          <button
                            onClick={() => copyToClipBoard(13)}
                            value="$department"
                            className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                          ></button>
                        </div>
                        <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                          <label htmlFor="" className="col-4 mb-0">
                            Position
                          </label>
                          <div className="p-2 col-5 me-3 bg-dynamic-field">
                            {"$position"}
                          </div>
                          <button
                            onClick={() => copyToClipBoard(13)}
                            value="$position"
                            className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                          ></button>
                        </div>
                        <div className="col-6 px-3 align-items-center d-flex justify-content-center px-1 mb-2">
                          <label htmlFor="" className="col-4 mb-0">
                            Date of resignation
                          </label>
                          <div className="p-2 col-5 me-3 bg-dynamic-field">
                            {"$date_of_resignation"}
                          </div>
                          <button
                            onClick={() => copyToClipBoard(13)}
                            value="$date_of_resignation"
                            className="p-2 col-2 fas fa-copy copyBtn h-100 btn btn-primary btn-sm"
                          ></button>
                        </div>

                        <div className="copy-modal-line"></div>
                      </div>
                    </Row>
                  </div>
                </div>
              </ResizableBox>
            </div>
          </Draggable>
        ) : null}
        {/* DRAGGABLE WRAPPER */}
      </React.Fragment>
    </div>
  );
};

export default LetterAddTemplate;
